module.exports = __webpack_public_path__ + "e8c64c2a3146cccf5d49266a3cd633eb.svg";